import React from 'react';

import { Icon } from '@instinet-analytics/semantic-ui-components';
import classNames from 'classnames';
import { Tooltip } from '@instinet-analytics/core-lib';

import './InfoBox.scss';

export interface InfoBoxProps {
    info?: JSX.Element | string;
    className?: string;
    isWarning?: boolean;
    tooltip?: string;
    onClickDismiss?: () => void;
}

export default function InfoBox(props: InfoBoxProps) {
    const { className, info, isWarning, onClickDismiss, tooltip } = props;

    const cssClasses = classNames(
        'InfoBox',
        className,
        isWarning && 'is-warning'
    );

    const iconWrapperClassName = isWarning ? 'warning-icon' : 'info-icon';
    const iconName = isWarning ? 'warning circle' : 'info';

    const infoPanelElement =
        typeof info === 'string' ? <span>{info}</span> : info;

    return (
        <div className={cssClasses}>
            <Tooltip text={tooltip}>
                <div className={iconWrapperClassName}>
                    <Icon name={iconName} />
                </div>
                <div className="info-panel">{infoPanelElement}</div>
                {onClickDismiss && (
                    <div className="link" onClick={onClickDismiss}>
                        Dismiss
                    </div>
                )}
            </Tooltip>
        </div>
    );
}
